import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux';
import { Modal } from 'vqp-common';
import { Button, Date, Input, Loading } from '../../../../components/common'
import { postRenewCupom } from '../../../../redux/actions/coupon';

const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  border-radius: 10px;
  background-color: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`
const Wrapper = styled.div`
  margin: 20px;
  min-height: 100px;
`
const Success = styled.div`
  margin: 1.5rem;
  font-size: 12px;
  color: ${props => props.theme.colors.success};
  text-align: center;
`
const Error = styled.div`
  margin: 1.5rem;
  font-size: 11px;
  color: ${props => props.theme.colors.error};
  text-align: center;
`
const Title = styled.h1`
  font-size: 24px;
  border-bottom: 1px solid ${props => props.theme.colors.lineGrey};
  padding: 2px 0 0 0;
  margin-bottom: 1.25rem;

  >div{
    margin: 0 4px;
  }
`
const Label = styled.h4`
  font-size: 14px;
`
const Name = styled.h2`
  font-size: 18px;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 1.25rem;
`
const Section = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  flex-direction: column;
  width: 100%
`
const Field = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`
const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-grow: 1;
    width: 100%;
`
export const DivButtonSave = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 0 10px 8px;
    padding: 8px;
    border-radius: 10px;
    align-items: center;
`
export const SaveButton = styled(Button)`
`
export const RenewCupomModal = ({ isOpen, cupomId, cupomName, onClose }) => {
  const [loading, setLoading] = useState()
  const [name, setName] = useState("");
  const [dateExpiration, setDateExpiration] = useState(null);
  const [formMessage, setFormMessage] = useState(null);
  const dispatch = useDispatch()

  useEffect(() => {
    handleInitialDate()
  }, [])
  const handleInitialDate = () => {
    let data = new window.Date(),
      dia = data.getDate().toString(),
      diaFormated = (dia.length === 1) ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(),
      mesFormated = (mes.length === 1) ? '0' + mes : mes,
      anoFormated = data.getFullYear();

    setDateExpiration(`${anoFormated}-${mesFormated}-${diaFormated}`)
  }
  const handleDateChange = ({ e }) => {
    setDateExpiration(e.target.value)
  }

  const handleRenewCupom = async () => {
    setLoading(true)
    if (name === '' || dateExpiration === '') {
      setFormMessage({
        type: "error",
        message: "É necessário preencher todos os campos para atualizar o cupom!"
      })
      setLoading(false)
      setTimeout(() => setFormMessage(null), 5000)
    } else {
      const data = {
        "Id": cupomId,
        "Nome": name,
        "Data": dateExpiration
      }

      const response = await dispatch(postRenewCupom(data))

      if (response.success) {
        setLoading(false)
        handleInitialDate()

        setFormMessage({
          type: "success",
          message: "Cupom atualizado com sucesso!"
        })

        setTimeout(() => onClose(), 5000)
      }
    }

  }
  return (
    <Modal isOpen={isOpen} onClose={onClose} boxWidth={"400px"}>
      {loading && (
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      )}
      <Wrapper>
        {!loading ? <>
          <Title>Atualizar Cupom</Title>
          <Section>
            <Label>Cupom que será inativado:</Label>
            <Name>{cupomName}</Name>
            <Row>
              <Field>
                <Label>Nome do cupom substituto</Label>
                <Input id='name' name="name" type="text" value={name} onChange={setName} />
              </Field>
            </Row>
            <Row>
              <Field>
                <Label>Data da expiração do novo cupom</Label>
                <Date className="coupons" value={dateExpiration} onChange={handleDateChange} />
              </Field>
            </Row>
            {formMessage && formMessage.type === 'success' ? <Success>{formMessage.message}</Success> :
              formMessage && formMessage.type === 'error' ? <Error>{formMessage.message}</Error> : <></>
            }
          </Section>
          <DivButtonSave>
            <SaveButton className="primary" onClick={handleRenewCupom}>
              Ok
            </SaveButton>
          </DivButtonSave>
        </> : <></>}
      </Wrapper>
    </Modal>
  )
}
